const arm926ejsPath = [
    {
        label: "IF",
        role: "IF",
        input: null,
        output: "IF/ID",
        latency: 1,
        canDelay: true
    },
    {
        label: "ID",
        role: "ID",
        input: "IF/ID",
        output: "ID/EX",
        latency: 1,
        canDelay: true
    },
    {
        label: "EX",
        role: "EX",
        input: "ID/EX",
        output: "EX/MEX",
        latency: 1,
        canDelay: true
    },
    {
        label: "MEX",
        role: "EX,MEM",
        input: "EX/MEX",
        output: "MEX/WB",
        latency: 1,
        canDelay: false
    },
    {
        label: "WB",
        role: "WB",
        input: "MEX/WB",
        output: null,
        latency: 1,
        canDelay: false
    }          
];

const arm926ejs = {
    name: "ARM926EJ-S",
    paths: {
        "int./": null,
        "int*": {
            phases: arm926ejsPath,
            opARequired: "EX",
            opBRequired: "EX",
            targetProvided: "MEX",
            registerWriteBack: "WB",
            registerReadOut: "ID"
        },
        "mem*": {
            phases: arm926ejsPath,
            opARequired: "EX",
            opBRequired: "MEX",
            targetProvided: "MEX",
            registerWriteBack: "WB",
            registerReadOut: "ID"
        },
        "jump*": {
            phases: arm926ejsPath,
            opARequired: "",
            opBRequired: "EX",
            targetProvided: "",
            registerWriteBack: "",
            registerReadOut: "ID"         
        }
    },
    description: "Az ARM926EJ-S pipeline szinte megegyezik az órán tanult egyszerű, 5 fokozatú pipeline-al. Az IF fázis betölti az utasítást, "
        +"az ID dekódolja és betölti a regiszter operandusokat. Az EX elvégzi az aritmetikai és logikai műveletek első lépését, "
        +"a MEX pedig a másodikat (a szorzás eleve két fázisú, a többi művelet csak egy, de a második fázisban lehetőség van a "
        +"szaturációs aritmetika érvényesítésére). A MEX fázis végére áll elő az eredmény. Memóriaműveletek esetén az EX fázis alatt elkészül a cím "
        +"(mivel a címen nem lehet szaturációs logikát érvényesíteni), a MEX fázisban pedig megtörténik a memóriaművelet. "
        +"Ugrás esetén az EX értékeli ki az ugrási címet és ugrási feltételt. "
        +"A WB pedig visszaírja az eredményt a regisztertárolóba. "
        +"A pipeline minden fázisa képes utasítást várakoztatni, minden forwarding út használata megengedett."
};

export default arm926ejs;